import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import TrustBar from "@/components/site/TrustBar";
import WhyMeta from "@/components/site/WhyMeta";
import Results from "@/components/site/Results";
import CaseStudies from "@/components/site/CaseStudies";
import ClientMarquee from "@/components/site/ClientMarquee";
import TeamProcess from "@/components/site/TeamProcess";
import ContactCTA from "@/components/site/ContactCTA";
import Footer from "@/components/site/Footer";

export default function HomePage() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <TrustBar />
        <WhyMeta />
        <Results />
        <CaseStudies />
        <ClientMarquee />
        <TeamProcess />
        <ContactCTA />
      </main>
      <Footer />
    </>
  );
}
